import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal, theme,  Row, Select, Spin ,} from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_SALE, URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from 'lodash';
import useDropdownItem from "../../common/useDropdownItem";
import { PRODUCT_TYPE } from "../../constants/string";
import CustomDatePicker from "../../common/CustomDatePicker";

export default function AddLotSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);
  const [debouncedSkimPond, setDebouncedSkimPond] = React.useState('')
  const pondSkimDropdown = useDropdownItem({manual : true, url: URL_SKIM.SKIM_POND, label: 'name', value:'id', pagination: true, params: { page_size: 50, name : debouncedSkimPond}})
  const debounceSkimPond = React.useCallback(_.debounce((_searchVal) => { setDebouncedSkimPond(_searchVal) }, 800), []);
  const [debouncedTrackSkim, setDebouncedTrackSkim] = React.useState('')
  const trackSkimDropdown = useDropdownItem({manual : true, url: URL_SKIM.SKIM_TRACK, label: 'name', value:'id', pagination: true, params: { page_size: 50, name : debouncedTrackSkim }})
  const debounceTrackSkim = React.useCallback(_.debounce((_searchVal) => { setDebouncedTrackSkim(_searchVal) }, 800), []);
  const editTarget = _.get(props, 'target.id', null)

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (editTarget) {
        await PATCH(`${URL_SKIM.SKIM_TRANSACTION}${editTarget}/`, data);
      } else {
        await POST(URL_SKIM.SKIM_TRANSACTION, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if(open) {
      pondSkimDropdown.fetchOptions();
    }
  },[debouncedSkimPond])

  React.useEffect(() => {
    if(open) {
      trackSkimDropdown.fetchOptions();
    }
  },[debouncedTrackSkim])

  React.useEffect(() => {
    if(open){
      pondSkimDropdown.fetchOptions();
      trackSkimDropdown.fetchOptions();

      setErrorMessages(null);
      if (target) {
        form.setFieldsValue(target);
      } else {
        form.resetFields();
      }
    }
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={editTarget ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={editTarget ? "แก้ไข" : "เพิ่มล็อตบ่อยางสกิม"}
      width={420}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: editTarget ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item
              label="เลขที่ล็อต"
              name="lot_no"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="Lot No." />
            </Form.Item>
          </Col>
          { !editTarget && 
            <Col span={24}>
              <CustomDatePicker
                label={'วันที่เริ่ม'} 
                name={"start_datetime"}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}/>
            </Col>
          }
          <Col span={24}>
            <Form.Item
              label="ลู่ยางสกิม"
              name="tracks"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Select 
                mode="multiple"
                initialvalues={"-"}
                autoComplete="off" 
                placeholder="ลู่ยางสกิม"
                showSearch
                filterOption={false}
                notFoundContent={trackSkimDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceTrackSkim}
                options={trackSkimDropdown.options}
                allowClear={"-"}/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="บ่อสกิม"
              name="ponds"
            >
              <Select
                mode="multiple"
                initialvalues={"-"}
                autoComplete="off" 
                placeholder="บ่อสกิม"
                showSearch
                filterOption={false}
                notFoundContent={pondSkimDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceSkimPond}
                options={pondSkimDropdown.options}
                allowClear={"-"}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
